$(document).ready(function() {
  var sidr = $('.sidr');
  sidr.append('<a href="#" class="sidr-close"></a>');

  $('.sidr-open').on('click', function(e) {
    sidr.toggleClass('open');
  });

  $('.sidr-close, .sidr a').on('click', function(e) {
    sidr.removeClass('open');
  });
});
